import ACIcon from "shared-components/Components/CustomIcons/ACICon/web"
import {CloseEyeIcon} from "shared-components/Components/CustomIcons/CloseEyeIcon/web"
import ElevatorIcon from "shared-components/Components/CustomIcons/ElevatorIcon/web"
import FurnitureIcon from "shared-components/Components/CustomIcons/FurnitureIcon/web"
import GarageIcon from "shared-components/Components/CustomIcons/GarageIcon/web"
import {VirtualTourIcon} from "shared-components/Components/CustomIcons/VirtualTourIcon/web"
import GardenIcon from "shared-components/Components/CustomIcons/GardenIcon/web"
import GrillIcon from "shared-components/Components/CustomIcons/GrillIcon/web"
import GymIcon from "shared-components/Components/CustomIcons/GymIcon/web"
import HeatingIcon from "shared-components/Components/CustomIcons/HeatingIcon/web"
import HouseIcon from "shared-components/Components/CustomIcons/HouseIcon/web"
import LaundryIcon from "shared-components/Components/CustomIcons/LaundryIcon/web"
import PetFriendlyIcon from "shared-components/Components/CustomIcons/PetFriendlyIcon/web"
import PoolIcon from "shared-components/Components/CustomIcons/PoolIcon/web"
import SeaViewIcon from "shared-components/Components/CustomIcons/SeaViewIcon/web"
import SecurityIcon from "shared-components/Components/CustomIcons/SecurityIcon/web"
import {UserOutlined} from "shared-components/Components/CustomIcons/UserOutlinedIcon/web"
import WifiIcon from "shared-components/Components/CustomIcons/WifiIcon/web"
import WoodStoveIcon from "shared-components/Components/CustomIcons/WoodStoveIcon/web"
import YardIcon from "shared-components/Components/CustomIcons/YardIcon/web"
import { Amenity } from "shared-components/Components/Filters/Amenities/Amenities.hook"

export const topAmenities = {
	UY: {
		1: [
			16, //balcon
			"garage", //garaje
			13, //parrillero, barbacoa
			70, //jardin,patio
		],
		2: [
			16, //balcon
			"garage", //garaje
			13, //parrillero, barbacoa
			70, //jardin,patio
		],
		4: [
			36, //aire acondicionado
			31, //internet
			13, // parrillero
			27, // piscina
			"seaView", //vista al mar
		],
	},
	CO: {
		1: [
			243, //ascensor,
			251, // balcon
			122, //conjunto cerrado
			352, //jardin,patio
			383, //piscina,
		],
		2: [
			243, //ascensor,
			251, // balcon
			122, //conjunto cerrado
			352, //jardin,patio
			383, //piscina,
		],
		4: [
			251, // balcon
			243, //ascensor,
			122, //conjunto cerrado
			352, //jardin,patio
			383, //piscina,
		],
	},
	PY: {
		1: [
			16, //balcon
			"garage", //garaje
			13, //parrillero, barbacoa
			70, //jardin,patio
		],
		2: [
			16, //balcon
			"garage", //garaje
			13, //parrillero, barbacoa
			70, //jardin,patio
		],
		4: [
			36, //aire acondicionado
			31, //internet
			13, // parrillero
			27, // piscina
		],
	},
	PE: {
		1: [
			16, //balcon
			"garage", //garaje
			13, //parrillero, barbacoa
			70, //jardin,patio
		],
		2: [
			16, //balcon
			"garage", //garaje
			13, //parrillero, barbacoa
			70, //jardin,patio
		],
		4: [
			36, //aire acondicionado
			31, //internet
			13, // parrillero
			27, // piscina
		],
	},
	BO: {
		1: [
			16, //balcon
			"garage", //garaje
			13, //parrillero, barbacoa
			70, //jardin,patio
		],
		2: [
			16, //balcon
			"garage", //garaje
			13, //parrillero, barbacoa
			70, //jardin,patio
		],
		4: [
			36, //aire acondicionado
			31, //internet
			13, // parrillero
			27, // piscina
		],
	},
};

export const amenities : Amenity[] = [
    {
        id: 222,
        nombre: "Acepta mascotas",
        grupo: "",
        IDtipos: [1,2,6],
        IDoperaciones: null,
        icon: PetFriendlyIcon,
    },
    {
        id: 69,
        nombre: "Amueblada",
        grupo: "",
        IDtipos: [1,2],
        IDoperaciones: [1,2],
        icon: FurnitureIcon,
    },
    {
        id: 36,
        nombre: "Aire Acondicionado",
        grupo: "",
        IDtipos: [1,2,5,4,6],
        IDoperaciones: [4],
        icon: ACIcon,
    },
    {
        id: 45,
        nombre: "Calefacción",
        grupo: "",
        IDtipos: [1,2,5,4,6],
        IDoperaciones: [1,2],
        icon: HeatingIcon
    },
    {
        id: 8,
        nombre: "Estufa a Leña",
        grupo: "",
        IDtipos: [1,2,6],
        IDoperaciones: null,
        icon: WoodStoveIcon
    },
    {
        id: 'garage',
        nombre: "Garage / Cochera",
        grupo: "Espacios",
        countryCodes: ['UY','PY','PE','BO','EC'],
        IDtipos: [1,2,5,4],
        IDoperaciones: null,
        icon: GarageIcon
    },
    {
        id: 'virtualTour',
        nombre: "Tour Virtual",
        grupo: "Espacios",
        IDtipos: [1,2,5,4],
        IDoperaciones: [1,2],
        icon: VirtualTourIcon
    },
    {
        id: 16,
        nombre: "Balcón / Terraza",
        grupo: "Espacios",
        countryCodes: ['UY','PY','PE','BO','EC'],
        IDtipos: [1,2],
        IDoperaciones: [1,2],
        icon: YardIcon
    },
    {
        id: 251,
        nombre: "Balcón / Terraza",
        grupo: "Espacios",
        countryCodes: ['CO'],
        IDtipos: [1,2],
        IDoperaciones: null,
        icon: YardIcon
    },
    {
        id: 13,
        nombre: "Parrillero / Barbacoa",
        grupo: "Espacios",
        IDtipos: [1,2,6],
        IDoperaciones: null,
        icon: GrillIcon
    },
    {
        id: 243,
        nombre: "Ascensor",
        grupo: "",
        IDtipos: [2,5,4],
        countryCodes: ['CO'],
        IDoperaciones: null,
        icon: ElevatorIcon
    },
    {
        id: 23,
        nombre: "GYM",
        grupo: "",
        IDtipos: [2],
        IDoperaciones: null,
        icon: GymIcon
    },
    {
        id: 25,
        nombre: "Lavandería",
        grupo: "",
        IDtipos: [2],
        IDoperaciones: null,
        icon: LaundryIcon
    },
    {
        id: 27,
        nombre: "Piscina",
        grupo: "",
        countryCodes: ['UY','PY','PE','BO','EC'],
        IDtipos: [1,2,6],
        IDoperaciones: null,
        icon: PoolIcon
    },
    {
        id: 383,
        nombre: "Piscina",
        grupo: "",
        countryCodes: ['CO'],
        IDtipos: [1,2,6],
        IDoperaciones: null,
        icon: PoolIcon
    },
    {
        id: 31,
        nombre: "Internet",
        grupo: "",
        IDtipos: [1,2,5,4,6],
        IDoperaciones: [4],
        icon: WifiIcon
    },
    {
        id: 70,
        nombre: "Patio / Jardín",
        countryCodes: ['UY','PY','PE','BO','EC'],
        grupo: "Espacios",
        IDtipos: [1,2],
        IDoperaciones: [1,2],
        icon: GardenIcon
    },
    {
        id: 352,
        nombre: "Patio / Jardín",
        countryCodes: ['CO'],
        grupo: "Espacios",
        IDtipos: [1,2],
        IDoperaciones: null,
        icon: GardenIcon
    },
    {
        id: 'seaView',
        nombre: "Vista al mar",
        grupo: "",
        IDtipos: [1,2,6],
        countryCodes: ['UY'],
        IDoperaciones: [4],
        icon: SeaViewIcon
    },
    {
        id: 393,
        nombre: 'Portería / Vigilancia',
        grupo: '',
        IDtipos: [1,2],
        IDoperaciones: [1,2],
        countryCodes: ['UY','PY','PE','BO','EC'],
        icon: SecurityIcon
    },
    {
        id: 122,
        nombre: "En Conjunto Cerrado",
        grupo: "",
        IDtipos: [1,2,14,15,16,17,6,4,5],
        countryCodes: ['CO'],
        IDoperaciones: null,
        icon: HouseIcon
    },
    {
        id: 'hideSeen',
        nombre: "Ocultar visitadas",
        grupo: "Otros",
        IDtipos: [1,2,14,15,16,17,6,4,5],
        countryCodes: [],
        IDoperaciones: null,
        logginRequired: true,
        icon: CloseEyeIcon
    },
    {
        id: 'privateOwner',
        nombre: "Publicada por dueño",
        grupo: "Otros",
        IDtipos: [1,2,6],
        IDoperaciones: null,
        countryCodes: ['UY','PY','PE','BO','EC'],
        icon: UserOutlined
    },
    {
        id: 'socialHousing',
        nombre: "Vivienda Promovida",
        grupo: "Otros",
        IDtipos: [1,2,6],
        countryCodes: ['UY'],
        IDoperaciones: [1,2],
        icon: HouseIcon
    }

]